import React from 'react'
import { IconProps } from 'types/common'

const MealPlannerIcon: React.FC<IconProps> = ({
  width = 24,
  height = 24,
  stroke = 'currentColor',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="3.25"
        y="5"
        width="17.5"
        height="16"
        rx="2.25"
        stroke={stroke}
        strokeWidth="1.5"
      />
      <path d="M3.25 9.25H20.75" stroke={stroke} strokeWidth="1.5" />
      <circle cx="8" cy="5" r="1.7" fill="white" stroke={stroke} strokeWidth="1.5" />
      <circle cx="16" cy="5" r="1.7" fill="white" stroke={stroke} strokeWidth="1.5" />
      <circle cx="8" cy="13" r="1" fill={stroke} />
      <circle cx="12" cy="13" r="1" fill={stroke} />
      <circle cx="16" cy="13" r="1" fill={stroke} />
      <circle cx="8" cy="17" r="1" fill={stroke} />
      <circle cx="12" cy="17" r="1" fill={stroke} />
      <circle cx="16" cy="17" r="1" fill={stroke} />
    </svg>
  )
}

export default MealPlannerIcon
